import { Stop } from '@rtls/core/models/convoy/stop.model';
import { chance, randomName } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const stopFactory = Factory.makeFactory<Stop>({
	name: Factory.each(() => randomName()),
	timezone: Factory.each(() => chance.timezone().name),
});
